import React, { useEffect } from "react";
import { Autocomplete } from "../../../../components/AutoComplete/AutoComplete";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";

/* You need `react-hook-form context` to use this component  */

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const MembershipDetailsForm = ({
  loadLocations,
  getLocations,
  locations,
  membershipTypes,
  membershipType,
  disabledFields = [],
  formData,
}) => {
  const { register, errors, control, setValue } = useFormContext();
  useEffect(() => {
    if (loadLocations && getLocations) {
      getLocations();
    }
  }, []);

  const handleMembershipTypeChange = (val, data) => {
    if (data) {
    setValue("type", data.name);
    setValue("id", data._id);
    return data.name;
    }
  };

  return (
    <div>
      {/* Same line inputs */}
      <div className="md:flex">
        {/* Hidden Field for setting a non-form value */}

        <input ref={register} name="id" type="hidden" />

        <div className="md:w-1/2 w-full mb-6">
          <label
            className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="center-location"
          >
            Center Location
          </label>
          <Autocomplete
            control={control}
            name="buildingId"
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            options={locations || []}
            textFieldProps={{ placeholder: "Select A Center" }}
            onChange={(val, data) => {
              if(data) {
                setValue("buildingId", data._id);
                return data._id;
              }
            }}
            disabled={disabledFields.indexOf("buildingId") > -1}
            // defaultValue={null}
          />

          {errors.buildingId && errors.buildingId.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.buildingId.message}</span>
            </div>
          )}
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="membership-type">
            Membership Type
          </label>
          <Autocomplete
            control={control}
            name="type"
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            options={membershipTypes || []}
            onChange={handleMembershipTypeChange}
            textFieldProps={{ placeholder: "Select Membership Type" }}
            disabled={disabledFields.indexOf("type") > -1}
          />

          {errors.type && errors.type.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.type.message}</span>
            </div>
          )}
        </div>
      </div>

      {/* Same line inputs */}
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="name">
            Company Name
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: errors.name && errors.name.message,
            })}
            id="name"
            placeholder="Company Name"
            name="name"
            ref={register}
          />
          {errors.name && errors.name.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.name.message}</span>
            </div>
          )}
        </div>
      </div>

      {/* Same line inputs */}
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="membership-start-date">
            Membership Start Date
          </label>

          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: errors.startDate && errors.startDate.message,
              "bg-disabledInput": disabledFields.indexOf("startDate") > -1,
            })}
            id="membership-start-date"
            placeholder="Membership Start Date"
            type="date"
            name="startDate"
            ref={register}
            readOnly={disabledFields.indexOf("startDate") > -1}
          />
          {errors.startDate && errors.startDate.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.startDate.message}</span>
            </div>
          )}
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="membership-end-date">
            End Date
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: errors.endDate && errors.endDate.message,
              "bg-disabledInput": disabledFields.indexOf("endDate") > -1,
            })}
            id="membership-end-date"
            placeholder="End Date of Membership"
            name="endDate"
            type="date"
            ref={register}
            readOnly={disabledFields.indexOf("endDate") > -1}
          />
          {errors.endDate && errors.endDate.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.endDate.message}</span>
            </div>
          )}
        </div>
      </div>

      {/* Same line inputs */}
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="securityDeposit">
            Deposit Amount
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors.securityDeposit && errors.securityDeposit.message,
              "bg-disabledInput":
                membershipType === "2gethr Connect" ||
                disabledFields.indexOf("securityDeposit") > -1,
            })}
            id="deposity-amount"
            placeholder="Deposit Amount"
            name="securityDeposit"
            ref={register}
            readOnly={
              membershipType === "2gethr Connect" ||
              disabledFields.indexOf("securityDeposit") > -1
            }
          />
          {errors.securityDeposit && errors.securityDeposit.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.securityDeposit.message}</span>
            </div>
          )}
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="locking-period">
            Locking Period
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors.lockingPeriod && errors.lockingPeriod.message,
              "bg-disabledInput":
                membershipType === "2gethr Connect" ||
                disabledFields.indexOf("lockingPeriod") > -1,
            })}
            id="locking-period"
            placeholder="Locking Period"
            name="lockingPeriod"
            ref={register}
            readOnly={
              membershipType === "2gethr Connect" ||
              disabledFields.indexOf("lockingPeriod") > -1
            }
          />
          {errors.lockingPeriod && errors.lockingPeriod.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.lockingPeriod.message}</span>
            </div>
          )}
        </div>
      </div>
      <div className="md:w-1/2 w-full mb-6">
        <label className={labelClass} htmlFor="annual-escalation">
          Annual Escalation
        </label>
        <input
          className={classNames({
            [inputClass]: true,
            [inputErrorClass]:
              errors.annualEscalation && errors.annualEscalation.message,
            "bg-disabledInput":
              membershipType === "2gethr Connect" ||
              disabledFields.indexOf("annualEscalation") > -1,
          })}
          id="annual-escalation"
          placeholder="Annual Escalation"
          name="annualEscalation"
          ref={register}
          readOnly={
            membershipType === "2gethr Connect" ||
            disabledFields.indexOf("annualEscalation") > -1
          }
        />
        {errors.annualEscalation && errors.annualEscalation.message && (
          <div className="text-xs text-red-500 flex flex-row-reverse">
            <span>{errors.annualEscalation.message}</span>
          </div>
        )}
      </div>

      {/* Same line inputs */}
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="membership-onboarding-charges">
            Membership Onboarding Charges
          </label>

          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors.onboardingCharges && errors.onboardingCharges.message,
              "bg-disabledInput":
                membershipType === "2gethr Connect" ||
                disabledFields.indexOf("onboardingCharges") > -1,
            })}
            id="membership-onboarding-charges"
            placeholder="Onboarding Charges"
            type="num"
            name="onboardingCharges"
            ref={register}
            readOnly={disabledFields.indexOf("onboardingCharges") > -1}
          />
          {errors.onboardingCharges && errors.onboardingCharges.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.onboardingCharges.message}</span>
            </div>
          )}
        </div>
        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="membership-exit-charges">
            Membership Exit Charges
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]:
                errors.exitCharges && errors.exitCharges.message,
              "bg-disabledInput":
                membershipType === "2gethr Connect" ||
                disabledFields.indexOf("exitCharges") > -1,
            })}
            id="membership-exit-charges"
            placeholder="Exit Charges"
            name="exitCharges"
            type="num"
            ref={register}
            readOnly={
              membershipType === "2gethr Connect" ||
              disabledFields.indexOf("exitCharges") > -1
            }
          />
          {errors.exitCharges && errors.exitCharges.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.exitCharges.message}</span>
            </div>
          )}
        </div>
      </div>
      <hr className="border b-2 my-8" />
    </div>
  );
};

export default React.memo(MembershipDetailsForm);
